// iter321 — Thèmes saisonniers des pop-ups promotionnels (vitrine + portail + aperçu admin)
// Chaque thème = palette + décor animé (particules CSS) + illustration IA par défaut.

const IMG = 'https://static.prod-images.emergentagent.com/jobs/4fd4851f-b710-4144-98dc-c1efb58fd731/images/';

export const PROMO_THEMES = {
  neutre: {
    label: 'Neutre / Golf',
    emojiFree: true,
    bg: 'linear-gradient(160deg, #10281C 0%, #1F4A33 60%, #2E6B4A 100%)',
    accent: '#D4AF37',
    accentText: '#1A2E22',
    text: '#FFFFFF',
    muted: 'rgba(255,255,255,0.72)',
    badgeBg: 'rgba(212,175,55,0.18)',
    badgeText: '#F3DC8A',
    particle: 'sparkle',
    image: `${IMG}859249bb3a22b02a506f26edacb0ee08f4c916d23eac366cf014625da7991d32.jpeg`,
    suggestedTitle: 'Offre du moment',
  },
  noel: {
    label: 'Noël',
    bg: 'linear-gradient(160deg, #0F2A1E 0%, #163D2B 55%, #7A1F2B 100%)',
    accent: '#E8C66B',
    accentText: '#2B1A05',
    text: '#FFFFFF',
    muted: 'rgba(255,255,255,0.75)',
    badgeBg: 'rgba(232,198,107,0.2)',
    badgeText: '#F6E3A6',
    particle: 'snow',
    image: `${IMG}9a7d27dada3202b8ce39a386d91756d641d93f14bc5c1c03c7bee86ad04a8ab9.jpeg`,
    suggestedTitle: 'Joyeuses fêtes au Kempferhof',
  },
  nouvel_an: {
    label: 'Nouvel An',
    bg: 'linear-gradient(160deg, #0B1026 0%, #1A2250 60%, #3B2E7A 100%)',
    accent: '#F5D06F',
    accentText: '#1B1A0A',
    text: '#FFFFFF',
    muted: 'rgba(255,255,255,0.72)',
    badgeBg: 'rgba(245,208,111,0.2)',
    badgeText: '#FBE9B0',
    particle: 'confetti',
    image: `${IMG}77915b612dcf354abf11d7b3220063cbab3fcb9d05245217e83a8ab5cf356853.jpeg`,
    suggestedTitle: 'Bonne année !',
  },
  saint_valentin: {
    label: 'Saint-Valentin',
    bg: 'linear-gradient(160deg, #4A0F22 0%, #7A1E3A 55%, #C0506E 100%)',
    accent: '#FFD6E0',
    accentText: '#4A0F22',
    text: '#FFFFFF',
    muted: 'rgba(255,255,255,0.78)',
    badgeBg: 'rgba(255,214,224,0.2)',
    badgeText: '#FFE4EC',
    particle: 'hearts',
    image: `${IMG}c71f1cc3286ad0b9a2dcd452d8463079cef86450940ae49b58084740f4e38b09.jpeg`,
    suggestedTitle: 'Saint-Valentin à deux',
  },
  paques: {
    label: 'Pâques',
    bg: 'linear-gradient(160deg, #2F5D3A 0%, #4F8A5C 55%, #A7D3A1 100%)',
    accent: '#FFF1A8',
    accentText: '#2F4A1E',
    text: '#FFFFFF',
    muted: 'rgba(255,255,255,0.8)',
    badgeBg: 'rgba(255,241,168,0.25)',
    badgeText: '#FFF7CC',
    particle: 'eggs',
    image: `${IMG}050a5a7b4f160a074becfabb29d601977a9d7d7f21d77f05e105eb5e86e1f8b3.jpeg`,
    suggestedTitle: 'Joyeuses Pâques',
  },
  fete_des_meres: {
    label: 'Fête des mères',
    bg: 'linear-gradient(160deg, #6B2E3F 0%, #B2566C 55%, #F2B5A0 100%)',
    accent: '#FFF3EC',
    accentText: '#6B2E3F',
    text: '#FFFFFF',
    muted: 'rgba(255,255,255,0.8)',
    badgeBg: 'rgba(255,243,236,0.25)',
    badgeText: '#FFF3EC',
    particle: 'petals',
    image: `${IMG}fe7d09b8607df19f2d9bbd7150937356cf23c93dbb343e13429829154b4719d1.jpeg`,
    suggestedTitle: 'Bonne fête maman',
  },
  halloween: {
    label: 'Halloween',
    bg: 'linear-gradient(160deg, #15101F 0%, #2E1B47 55%, #C25A1A 100%)',
    accent: '#FF9A3C',
    accentText: '#1F1206',
    text: '#FFFFFF',
    muted: 'rgba(255,255,255,0.72)',
    badgeBg: 'rgba(255,154,60,0.2)',
    badgeText: '#FFC48A',
    particle: 'bats',
    image: `${IMG}085568b0db97c946a1f6e7948877c6ac1c52219925697efb7d96fcde25fabe57.jpeg`,
    suggestedTitle: 'Halloween au golf',
  },
  ete: {
    label: 'Été',
    bg: 'linear-gradient(160deg, #0E5A7A 0%, #1C8FB0 55%, #7FD3C9 100%)',
    accent: '#FFE27A',
    accentText: '#1D3B2A',
    text: '#FFFFFF',
    muted: 'rgba(255,255,255,0.82)',
    badgeBg: 'rgba(255,226,122,0.25)',
    badgeText: '#FFF0B3',
    particle: 'sun',
    image: `${IMG}f44de866bbb57a241d5f32c62a7d6f1c351f4ddf854a06a1c5bb1751dc6e4697.jpeg`,
    suggestedTitle: 'Offres d\'été',
  },
  rentree: {
    label: 'Rentrée',
    bg: 'linear-gradient(160deg, #3A2A14 0%, #7A5420 55%, #C9933A 100%)',
    accent: '#FFF0C9',
    accentText: '#3A2A14',
    text: '#FFFFFF',
    muted: 'rgba(255,255,255,0.78)',
    badgeBg: 'rgba(255,240,201,0.22)',
    badgeText: '#FFF4D6',
    particle: 'leaves',
    image: `${IMG}8f541619d860d5ab6d849c8fe195e5e46b57ed6e644a9a84c31528e6cb7e37f0.jpeg`,
    suggestedTitle: 'C\'est la rentrée !',
  },
  black_friday: {
    label: 'Black Friday',
    bg: 'linear-gradient(160deg, #050505 0%, #1A1A1A 60%, #333333 100%)',
    accent: '#D4AF37',
    accentText: '#111111',
    text: '#FFFFFF',
    muted: 'rgba(255,255,255,0.7)',
    badgeBg: 'rgba(212,175,55,0.2)',
    badgeText: '#F3DC8A',
    particle: 'sparkle',
    image: `${IMG}4f071507ab2d7e7b8f25c258c4f01059e0362ce23f9d71c2217bcdcbe3d88b88.jpeg`,
    suggestedTitle: 'Black Friday',
  },
};

export const PROMO_THEME_KEYS = Object.keys(PROMO_THEMES);

export const getPromoTheme = (key) => PROMO_THEMES[key] || PROMO_THEMES.neutre;

export const FREQUENCY_LABELS = {
  always: 'À chaque visite',
  daily: '1 fois par jour',
  once: '1 fois par visiteur',
};

export const LINK_KIND_LABELS = {
  auto: 'Automatique (lien de la bonne affaire)',
  vitrine_page: 'Page du site vitrine',
  public_event: 'Événement public (inscription)',
  url: 'URL libre',
};
